import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidemenu from '../base/sidemenu';
import axios from "axios";
import { formatMobilePhone, formatOfficePhone } from '../../utils/phoneFormatter'
import "./AdminWriteRedesign.css";

export default function UserWrite() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [authList, setAuthList] = useState([]);
  const [deptList, setDeptList] = useState([]);

  const [form, setForm] = useState({
    name: "",
    mobile_phone: "",
    phone: "",
    department: "",
    auth: "",
    username: "",
    email: "",
    password: "",
    passwordConfirm: "",
  });

  

  useEffect(() => {
    const fetchSelectLists = async () => {
      try {
        const [authRes, deptRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API_BASE_URL}/auth`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(`${process.env.REACT_APP_API_BASE_URL}/department`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        setAuthList(Array.isArray(authRes.data) ? authRes.data : authRes.data.auth || []);
        setDeptList(Array.isArray(deptRes.data) ? deptRes.data : deptRes.data.department || []);
      } catch (error) {
        console.error("선택박스 데이터 불러오기 실패:", error);
        alert("소속 또는 권한 정보를 불러오는 데 실패했습니다.");
      }
    };

    fetchSelectLists();
  }, [token]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobile_phone") {
      const formatted = formatMobilePhone(value);
      setForm(prev => ({ ...prev, [name]: formatted }));
    } else if (name === "phone") {
      const formatted = formatOfficePhone(value);
      setForm(prev => ({ ...prev, [name]: formatted }));
    } else {
      setForm(prev => ({ ...prev, [name]: value }));
    }
    
  };

  const handleSubmit = async () => {
    
    const {
      username, password, passwordConfirm,
      name, auth, department, email, phone, mobile_phone
    } = form;

    if (password !== passwordConfirm) {
      alert("비밀번호가 일치하지 않습니다.");
      return;
    }

    const payload = {
      username,
      password,
      name,
      auth,
      department,
      email,
      phone,
      mobile_phone
    };

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin`, payload, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.data.success === false) {
        alert(response.data.message);
        return;
      }
      alert(response.data.message);
      // alert("관리자 등록이 완료되었습니다.");
      navigate("/admin");
      
      } catch (error) {
      console.error("관리자 등록 실패:", error.response?.data || error.message);
      alert("관리자 등록에 실패했습니다.");
      }
  };

return (
  <div className="flex admin-write-redesign-layout">
    <Sidemenu />

    <main className="admin-write-redesign-content">
      <div className="aw-page">
        <div className="aw-top">
          <button className="aw-back" onClick={() => navigate(-1)}>
            ← 관리자 목록
          </button>
        </div>

        <div className="aw-heading">
          <h2>관리자 등록</h2>
          <p>새로운 관리자 계정 및 소속 정보를 등록할 수 있습니다.</p>
        </div>

        <section className="aw-card">
          <div className="aw-card-title">
            <h3>기본 정보</h3>
            <span>관리자 계정 및 연락처 정보</span>
          </div>

          <div className="aw-grid">
            <div className="aw-field">
              <label htmlFor="aw-name">이름 <em>*</em></label>
              <input
                id="aw-name"
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="이름을 입력하세요."
              />
            </div>

            <div className="aw-field">
              <label htmlFor="aw-username">아이디 <em>*</em></label>
              <input
                id="aw-username"
                type="text"
                name="username"
                value={form.username}
                onChange={handleChange}
                placeholder="아이디를 입력하세요."
              />
            </div>

            <div className="aw-field">
              <label htmlFor="aw-mobile">휴대폰 번호</label>
              <input
                id="aw-mobile"
                type="text"
                name="mobile_phone"
                value={form.mobile_phone}
                onChange={handleChange}
                placeholder="휴대폰 번호를 입력하세요."
                maxLength={13}
              />
            </div>

            <div className="aw-field">
              <label htmlFor="aw-phone">내선번호</label>
              <input
                id="aw-phone"
                type="text"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="내선번호를 입력하세요."
                maxLength={13}
              />
            </div>

            <div className="aw-field">
              <label htmlFor="aw-email">이메일</label>
              <input
                id="aw-email"
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="이메일을 입력하세요."
              />
            </div>

            <div className="aw-field">
              <label htmlFor="aw-department">소속 <em>*</em></label>
              <select
                id="aw-department"
                name="department"
                value={form.department}
                onChange={handleChange}
              >
                <option value="" disabled>소속을 선택하세요.</option>
                {deptList.map(dept => (
                  <option key={dept.id} value={dept.id}>
                    {dept.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="aw-field">
              <label htmlFor="aw-auth">권한 <em>*</em></label>
              <select
                id="aw-auth"
                name="auth"
                value={form.auth}
                onChange={handleChange}
              >
                <option value="" disabled>권한을 선택하세요.</option>
                {authList.map(auth => (
                  <option key={auth.id} value={auth.id}>
                    {auth.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </section>

        <section className="aw-card">
          <div className="aw-card-title">
            <h3>비밀번호 설정</h3>
            <span>관리자 계정에 사용할 비밀번호를 설정하세요.</span>
          </div>

          <div className="aw-grid">
            <div className="aw-field">
              <label htmlFor="aw-password">비밀번호 <em>*</em></label>
              <input
                id="aw-password"
                type="password"
                name="password"
                value={form.password}
                onChange={handleChange}
                autoComplete="new-password"
                placeholder="비밀번호를 입력하세요."
              />
            </div>

            <div className="aw-field">
              <label htmlFor="aw-password-confirm">비밀번호 확인 <em>*</em></label>
              <input
                id="aw-password-confirm"
                type="password"
                name="passwordConfirm"
                value={form.passwordConfirm}
                onChange={handleChange}
                autoComplete="new-password"
                placeholder="비밀번호를 다시 입력하세요."
              />
            </div>
          </div>
        </section>

        <p className="aw-required-note">
          <em>*</em> 표시는 필수 입력사항입니다.
        </p>

        <div className="aw-actions">
          <button className="aw-secondary" onClick={() => navigate(-1)}>
            뒤로
          </button>
          <button className="aw-primary" onClick={handleSubmit}>
            등록완료
          </button>
        </div>
      </div>
    </main>
  </div>
);


}
